import type { SuperBillingRow } from '@tandemone/types'
import { isCompedSubscription, PLAN_CATALOG } from '@tandemone/types'
import { Link } from 'react-router'

import { Badge } from '@/components/ui/badge'
import { MobileList } from '@/components/ui/mobile-list'

import { formatBillingDate } from './plan-price'
import { ReceiptLink, SuperBillingStatusBadge } from './super-columns'

function formatLastPaid(iso: string | null): string {
  return iso ? formatBillingDate(iso) : 'never'
}

export function SuperBillingMobileList({
  items,
  emptyMessage
}: {
  items: SuperBillingRow[]
  emptyMessage: string
}) {
  return (
    <MobileList isEmpty={items.length === 0} emptyMessage={emptyMessage}>
      {items.map(row => (
        <li key={row.companyId} className='flex items-start gap-3 px-4 py-3'>
          {/* the receipt link sits outside it: a link inside a link is not
              clickable on its own. */}
          <Link
            to={`/super/billing/${row.companySlug}`}
            className='flex min-w-0 flex-1 flex-col gap-1.5'
          >
            <span className='truncate text-[13px] font-medium text-ink'>
              {row.companyName}
            </span>
            <span className='truncate text-[12px] text-ink-soft'>
              {row.planId ? PLAN_CATALOG[row.planId].label : 'No plan'}
              {row.billingInterval
                ? ` · ${row.billingInterval === 'year' ? 'Annually' : 'Monthly'}`
                : ''}
            </span>
            <span className='text-[11px] text-ink-muted'>
              Paid {formatLastPaid(row.lastPaidAt)}
            </span>
            <div className='flex flex-wrap items-center gap-2 pt-1'>
              <SuperBillingStatusBadge row={row} />
              {isCompedSubscription(row) && (
                <Badge variant='outline'>Comped</Badge>
              )}
            </div>
          </Link>

          <div className='shrink-0 self-start'>
            <ReceiptLink row={row} />
          </div>
        </li>
      ))}
    </MobileList>
  )
}
